// @flow
import React, {Component} from 'react';
import './Legend.css';
import {COLOR_REPUBLICAN_MAX, COLOR_DEMOCRAT_MAX, COLOR_NEUTRAL} from './constants';


export default class Legend extends Component {

  render() {
    return (
      <div className="legend">
        <span className="swatch" style={{backgroundColor: COLOR_REPUBLICAN_MAX}}>Republican</span>
        <span className="swatch" style={{backgroundColor: COLOR_NEUTRAL}}>Neutral</span>
        <span className="swatch" style={{backgroundColor: COLOR_DEMOCRAT_MAX}}>Democrat</span>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/Legend.js
 **/